import { API } from "../../../api/constants"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"

export const getCompanyData = async () => authenticatedAxiosInstance.get(API + "/global-settings").then((res) => res.data)

export const getColorAndLogo = async () => authenticatedAxiosInstance.get(API + "/global-settings/color-and-logo").then((res) => res.data)

export const updateCompanyData = async (data: any) => authenticatedAxiosInstance.patch(API + "/global-settings", data).then((res) => res.data)

export const addLogoToCompanySettings = async (data: { logo: FormData }) =>
    authenticatedAxiosInstance.post(API + "/global-settings/logo", data.logo, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => res.data)

export const getLogo = async () => {
    try {
        const response = await authenticatedAxiosInstance.get(`${API}/global-settings/logo`, {
            responseType: "blob",
        })
        return URL.createObjectURL(response.data)
    } catch (error) {
        console.error("Error fetching image:", error)
        throw error
    }
}
